export default __webpack_public_path__ + "static/media/black-color-book.99eb0791.png";